// ── السنة المالية المختارة — لكل تبويب على حدة ─────────────────────────────
// كل تبويب في المتصفح يحتفظ بسنته في sessionStorage، فلو فتح المحاسب 2027 في تبويب و2026 في
// تبويب آخر لا يُرسل أحدهما سنة الآخر (localStorage مشترك بين كل التبويبات).
// التبويب الجديد يبدأ من آخر سنة اختارها المستخدم (localStorage) ثم يستقل بها.
// كل وصول للتخزين محمي: في التصفح الخاص أو عند حظر التخزين قد يرمي المتصفح استثناءً،
// وهذه الدوال تُستدعى عند الإقلاع ومع كل طلب — فلا يجوز أن تُسقط الواجهة.

const KEY = 'selectedFiscalYearId';

function safeGet(storage: () => Storage): string | null {
  try { return storage().getItem(KEY); } catch { return null; }
}

function safeSet(storage: () => Storage, value: string): void {
  try { storage().setItem(KEY, value); } catch { /* storage unavailable */ }
}

function safeRemove(storage: () => Storage): void {
  try { storage().removeItem(KEY); } catch { /* storage unavailable */ }
}

export function getActiveFiscalYearId(): string | null {
  let value = safeGet(() => sessionStorage);
  if (!value) {
    value = safeGet(() => localStorage);
    if (value) safeSet(() => sessionStorage, value);
  }
  return value;
}

export function setActiveFiscalYearId(id: number): void {
  safeSet(() => sessionStorage, id.toString());
  safeSet(() => localStorage, id.toString());   // default for tabs opened later
}

export function clearActiveFiscalYearId(): void {
  safeRemove(() => sessionStorage);
  safeRemove(() => localStorage);
}
